import { ValidationError } from "sequelize"
import { ACTIVE, INACTIVE } from "const"
import {
    MtModule,
    MtModuleCreate,
    MtModuleSave,
    MtModuleChangeStatus,
} from "server/models"
import { OrderType, ActiveInactive } from "client/utils"
import { GET, POST, sort, search, validate } from "client/store/utils"
import { LangType } from "client/store"
import {
    ModuleFilters,
    ModuleList,
    ModuleValidation,
} from "./types"


export const LoadAllModules = () => (
    GET("/mtModule/all")
    .then((modules: MtModule[]) => {
        const moduleList: ModuleList = {}
        modules.forEach((module) => {
            moduleList[module.id] = module
        })
        return moduleList
    })
)

export const LoadModuleById = (moduleId: number) => (
    GET(`/mtModule/id/${moduleId}`)
    .then((module: MtModule) => module)
)

export const SaveModule = (
    id: number,
    module: MtModuleCreate,
    lang: LangType,
) => {
    const data: MtModuleSave = {
        id,
        module,
    }
    return POST(
        "/mtModule/save",
        JSON.stringify(data),
    ).then((res) => {
        const newModule = res as MtModule
        const error = res as ValidationError
        return {
            newModuleId: newModule.id || null,
            validation: <ModuleValidation>validate(error, lang),
        }
    })
}

export const ChangeModuleStatus = (module: MtModule) => {
    const status: ActiveInactive = module.status === ACTIVE ? INACTIVE : ACTIVE
    const data: MtModuleChangeStatus = {
        id: module.id,
        status,
    }
    return POST(
        "/mtModule/changeStatus",
        JSON.stringify(data),
    ).then((updatedRows: [number]) => (
        updatedRows && updatedRows.length && updatedRows[0] === 1
            ? status
            : module.status
    ))
}

export const SortModules = (
    modules: MtModule[],
    sortColumn: keyof MtModule,
    sortOrder: OrderType,
    filters: ModuleFilters,
): number[] => {
    const modulesFiltered = modules.filter((module) => {
        let showRow = true
        if (filters.status && module.status !== filters.status) showRow = false
        else if (filters.search) showRow = search(filters.search, module)
        return showRow
    })
    modulesFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const moduleIds: number[] = []
    modulesFiltered.forEach((module) => moduleIds.push(module.id))

    return moduleIds
}
